import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
  selector: 'sm-secondary-button',
  templateUrl: './secondary-button.component.html',
  styleUrls: ['./secondary-button.component.less']
})
export class SecondaryButtonComponent implements OnInit, OnChanges {

  @Input() isDisabled = false;
  @Input() isLoading = false;
  @Input() label = '';
  @Input() isFullWidth = false;
  @Input() textClasses = 'text-base';
  @Input() iconClasses = 'text-xl';
  @Input() spinnerClasses = '';
  @Input() isActive = false;
  @Input() icon = '';
  @Input() spinnerDiameter = 24;
  @Input() spinnerStrokeWidth = 2;

  @Output() click = new EventEmitter();

  isHovered = false;
  finalIcon = '';

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.icon.length > 0 && this.finalIcon.length === 0) {
      this.finalIcon = this.icon;
    }
  }

  ngOnInit(): void {
  }

  onClick() {
    if (!this.isLoading)
      this.click.emit();
  }

  onHover(isHoverd: boolean) {
    this.isHovered = isHoverd;
  }

  getIconClasses(): any {
    let result = this.iconClasses;

    if (!this.isHovered)
      result += ' material-icons-outlined';//pogrubienie

    return result;
  }
}
